export const BUTTON_DISABLED_TOOLTIP_MESSAGE = '權限不足'

export const ORG_EDIT_SCOPE = 'org:edit' // 編輯組織
export const ORG_CLONE_SCOPE = 'org:clone' // 複製組織
export const ORG_REMOVE_SCOPE = 'org:remove' // 刪除組織
export const ORG_TRANSFER_DATA_SCOPE = 'org:transfer_data' // 轉移組織資料
export const USER_EDIT_SCOPE = 'user:edit' // 編輯用戶 v
export const USER_REMOVE_SCOPE = 'user:remove' // 刪除用戶
export const ROLE_EDIT_SCOPE = 'role:edit' // 編輯角色
export const ROLE_REMOVE_SCOPE = 'role:remove' // 刪除角色
export const PLATFORM_BILL_LIST_SCOPE = 'platform:bill:list' // 查看帳單
export const BILL_TAKEOUT_LIST_SCOPE = 'bill:takeout_list' // 查看帳單
export const BILL_TAKEOUT_SCOPE = 'bill:takeout' // 提領帳單 v
export const OBJECT_LIST_SCOPE = 'object:list' // 查看物件 v
export const OBJECT_CREATE_SCOPE = 'object:edit'
export const OBJECT_REMOVE_SCOPE = 'object:remove' // 刪除物件
export const TAG_EDIT_SCOPE = 'tag:edit' // 編輯標籤
export const TAG_REMOVE_SCOPE = 'tag:remove' // 刪除標籤
export const CONTRACT_LIST_SCOPE = 'contract:list' // 查看合約 v
export const CONTRACT_EDIT_SCOPE = 'contract:edit' // 編輯合約
export const CONTRACT_REMOVE_SCOPE = 'contract:remove' // 刪除合約
export const CONTRACT_SIGNING_SCOPE = 'contract:signing' // 合約簽署
export const REPAIR_LIST_SCOPE = 'repair:list' // 查看維修
export const REPAIR_EDIT_SCOPE = 'repair:edit' // 編輯維修
export const REPAIR_REMOVE_SCOPE = 'repair:remove' // 刪除維修
export const BILL_LIST_SCOPE = 'bill:list' // 查看帳單 v
export const BILL_EDIT_SCOPE = 'bill:edit' // 編輯帳單
export const BILL_REMOVE_SCOPE = 'bill:remove' // 刪除帳單
export const MANAGEMENT_REPORT_LIST_SCOPE = 'management:report:list' // 查看管理報表
export const MANAGEMENT_REPORT_EXPORT_EXCEL_SCOPE = 'management:report:export_excel' // 匯出Excel (管理報表)
export const EXPENSE_LIST_SCOPE = 'expense:list' // 查看支出 v
export const EXPENSE_EDIT_SCOPE = 'expense:edit' // 編輯支出
export const EXPENSE_REMOVE_SCOPE = 'expense:remove'
export const IOT_DEVICE_LIST_SCOPE = 'iot_device:list' // 查看物聯網設備
export const IOT_DEVICE_EDIT_SCOPE = 'iot_device:edit' // 編輯物聯網設備 v
export const IOT_DEVICE_REMOVE_SCOPE = 'iot_device:remove' // 刪除物聯網設備
export const IOT_DEVICE_CHARGE_AMOUNT_SCOPE = 'iot_device:charge_amount' // 計費
export const PLUGIN_CUSTOMER_WEBSITE_BRAND_EDIT_SCOPE = 'plugin:customer_website:brand:edit' // 編輯品牌
export const PLUGIN_CUSTOMER_WEBSITE_OBJECT_EDIT_SCOPE = 'plugin:customer_website:object:edit' // 編輯物件
export const PLUGIN_INVOICE_MANAGE_INVOICE_LIST_SCOPE = 'plugin:invoice_manage:invoice:list' // 查看發票
export const PLUGIN_INVOICE_MANAGE_INVOICE_CREATE_SCOPE = 'plugin:invoice_manage:invoice:create' // 新增發票
export const PLUGIN_INVOICE_MANAGE_INVOICE_REVOKE_SCOPE = 'plugin:invoice_manage:invoice:revoke' // 作廢發票
export const PLUGIN_CLIENT_SERVICE_FEE_ORG_EDIT_SCOPE = 'plugin:client_service_fee:org:edit' // 編輯客戶服務費
export const PLUGIN_CLIENT_SERVICE_FEE_OBJECT_EDIT_SCOPE = 'plugin:client_service_fee:object:edit' // 編輯客戶服務費
// 社宅權限
export const PLUGIN_AFFORDABLE_HOUSE_CONTRACT_LIST_SCOPE = 'plugin:affordable_house:contract:list' // 查看案源媒合文件 v
// export const SOCIAL_HOUSE_CASE_CREATE_SCOPE = 'plugin:affordable_house:contract:edit' // 編輯案源媒合文件
export const PLUGIN_AFFORDABLE_HOUSE_CASE_CREATE_SCOPE = 'plugin:affordable_house:contract:edit' // 編輯案源媒合文件
export const PLUGIN_AFFORDABLE_HOUSE_CASE_EDIT_SCOPE = 'plugin:affordable_house:contract:edit' // 編輯案源媒合文件
export const PLUGIN_AFFORDABLE_HOUSE_CASE_REMOVE_SCOPE = 'plugin:affordable_house:contract:remove' // 刪除案源媒合文件
export const PLUGIN_AFFORDABLE_HOUSE_MATCH_CREATE_SCOPE = 'plugin:affordable_house:contract:edit' // 編輯案源媒合文件
export const PLUGIN_AFFORDABLE_HOUSE_MATCH_EDIT_SCOPE = 'plugin:affordable_house:contract:edit' // 編輯案源媒合文件
export const PLUGIN_AFFORDABLE_HOUSE_MATCH_REMOVE_SCOPE = 'plugin:affordable_house:contract:remove' // 刪除案源媒合文件
export const PLUGIN_AFFORDABLE_HOUSE_MATCH_DOCUMENT_EDIT_SCOPE = 'plugin:affordable_house:contract:edit' // 編輯案源媒合文件
export const PLUGIN_AFFORDABLE_HOUSE_PDF_RELEASE_SCOPE = 'plugin:affordable_house:pdf:release' // 去除文件浮水印
export const PLUGIN_AFFORDABLE_HOUSE_REPORT_EXPORT_EXCEL_SCOPE = 'plugin:affordable_house:report:export_excel' // 匯出Excel (媒合匯出)
export const PLUGIN_AFFORDABLE_HOUSE_INVENTORY_EDIT_SCOPE = 'plugin:affordable_house:inventory:edit' // 編輯清冊
export const PLUGIN_AFFORDABLE_HOUSE_INVENTORY_REVOKE_SCOPE = 'plugin:affordable_house:inventory:contract_release:revoke' // 作廢清冊

export const PLUGIN_PROPERTY_OWNER_MANAGE_PROPERTY_OWNER_LIST_SCOPE = 'plugin:property_owner_manage:property_owner:list' // 查看物業所有者
export const PLUGIN_PROPERTY_OWNER_MANAGE_PROPERTY_OWNER_EDIT_SCOPE = 'plugin:property_owner_manage:property_owner:edit' // 編輯物業所有者
export const PLUGIN_PROPERTY_OWNER_MANAGE_PROPERTY_OWNER_REMOVE_SCOPE = 'plugin:property_owner_manage:property_owner:remove' // 刪除物業所有者
export const PLUGIN_PROPERTY_OWNER_MANAGE_PROPERTY_OWNER_SET_WARNING_SCOPE = 'plugin:property_owner_manage:property_owner:set_warning' // 設定物業所有者警告
export const PLUGIN_PROPERTY_OWNER_MANAGE_EVENT_LIST_SCOPE = 'plugin:property_owner_manage:event:list' // 查看事件
export const PLUGIN_PROPERTY_OWNER_MANAGE_EVENT_EDIT_SCOPE = 'plugin:property_owner_manage:event:edit' // 編輯事件
export const PLUGIN_PROPERTY_OWNER_MANAGE_EVENT_REMOVE_SCOPE = 'plugin:property_owner_manage:event:remove' // 刪除事件
export const PLUGIN_PROPERTY_OWNER_MANAGE_REPORT_EXPORT_EXCEL_SCOPE = 'plugin:property_owner_manage:report:export_excel' // 匯出Excel (事件)
export const PLATFORM_PAYMENT_CREDIT_CARD_BIND_SCOPE = 'platform:payment:credit_card_bind' // 綁定信用卡
export const ORG_EXIT_SCOPE = 'org:exit'
